import React from 'react';
import { Loader2 } from 'lucide-react';

/** Semi-transparent overlay for in-place refetch (previous data stays visible underneath). */
export default function TableFetchOverlay({ show, label }) {
  if (!show) return null;

  return (
    <div
      className="absolute inset-0 z-10 flex items-center justify-center bg-dark-bg/55 backdrop-blur-[2px] transition-opacity duration-200"
      aria-busy="true"
      aria-live="polite"
    >
      <div className="flex items-center gap-3 rounded-xl border border-dark-border bg-dark-card/95 px-5 py-3 shadow-xl shadow-black/40">
        <Loader2 className="w-5 h-5 text-primary animate-spin shrink-0" aria-hidden />
        <span className="text-sm font-medium text-dark-text-secondary">{label}</span>
      </div>
    </div>
  );
}
